/** Маркер в текстах (диалоги флоу, ответы AI): показываем вместо него ник игрока. */
export const PLAYER_NAME_PLACEHOLDER = '*name*';

/**
 * @param {string|null|undefined} text
 * @param {string|null|undefined} nickname — тримится; пустой → маркер убирается из строки
 */
export function replacePlayerNamePlaceholder(text, nickname) {
  const s = text == null ? '' : String(text);
  if (!s.includes(PLAYER_NAME_PLACEHOLDER)) return s;
  const nick = String(nickname ?? '').trim();
  const parts = s.split(PLAYER_NAME_PLACEHOLDER);
  if (!nick) return parts.join('');
  return parts.join(nick);
}
